import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import sidebarReducer from './features/sidebar/sidebarSlice';
import classSubjectsReducer from './features/classSubjects/classSubjectsSlice';
import booksReducer from './features/books/booksSlice';
import { apiClient, nucluesApiGatewayClient } from './api/client';
import { booksApi } from './api/books';
import { setupListeners } from '@reduxjs/toolkit/query';
import toggleReducer from './features/toggle/toggleSlice';
import productReducer from './features/productType/productTypeSlice';
import activitiesDropdownReducer from './features/activitiesDropdown/activeDropdownSlice';
import currentBookReducer from './features/currentBook/currentBookSlice';
import selectReducer from './features/books/selectSlice';
import TOCOpenReducer from './features/TOC/TOCOpenSlice';
import bookmarksReducer from './features/bookMark/bookMarkSlice';
import notesReducer from './features/notes/noteSlice';
import highlightsReducer from './features/highlights/highlightsSlice';
import initialTOCDataReducer from './features/initialTocData/initialTocDataSlice';
import setSelectOpen from './features/Select/selectOpenSlice';
import LPOpenReducer from './features/LP/LPOpenSlice';
import WidgetOpenReducer from './features/Widget/WidgetOpenSlice';
import TeacherPendingActionsWidgetOpenReducer from './features/techerPendingActionsWidgetModal/teacherPendingActionsWidgetModalSlice';
import WidgetModalOpenReducer from './features/widgetModal/WidgetModalOpenSlice';
import DQBOpenReducer from './features/DQB/DQBOpenSlice';
import EvaluateOpenReducer from './features/Evaluate/EvaluateOpenSlice';
import offlineModalReducer from './features/offlineModal/offlineModalSlice';
import IframeDisplayReducer from './features/iframeDisplay/iframeDisplaySlice';
import SideBarConfigReducer from './features/sideBarConfigSlice/sideBarConfigSlice';
import SchoolInfoReducer from './features/schoolInfo/schoolInfoSlice';
import resourceConfigReducer from './features/resourceConfig/resourceConfigSlice';
import buildrModalReducer from './features/buildrModal/buildrModalSlice';
import jasperReducer from './features/jasper/jasperSlice';
import leadAcademyReducer from './features/leadAcademy/leadAcademySlice';
import lpPdfPlayerReducer from './features/LpPdfPlayer/LpPdfPlayerSlice';
import evaluatePdfPlayerReducer from './features/EvaluatePdfPlayer/EvaluatePdfPlayerSlice';
import CTRBPdfPlayerDataReducer from "./features/CTRBPdfPlayer/CTRBPdfPlayerSlice"
import FullScreenModalReducer from './features/FullScreenModal/FullScreenModalSlice';
import pageViewReducer from './features/pageView/pageViewSlice';
import JasperIframeReducer from './features/jasperIframe/jasperIframeSlice';
import FullScreenModeReducer from './features/FullScreenMode/fullScreenMode';
import SubjectIdPlatformMapReducer from './features/jasper/subjectIdPlatformMapSlice';
import PreferenceReducer from './features/Preferences/PreferencesSlice';
import ResourceViewerReducer from './features/resourceViewer/resourceViewer';
import TransparentModalReducer from './features/transparentModal/TransparentModal';
import JasperHeaderSearchReducer from './features/jasperHeaderSearch/jasperHeaderSearchSlice';
import JasperBooksReducer from './features/jasperBooks/jasperBooksSlice';
import AssetViewerReducer from './features/assetViewer/assetViewerSlice';
import AndroidMediaPlayerReducer from './features/androidMediaPlayer/androidMediaPlayerSlice';
const store = configureStore({
    reducer: {
        auth: authReducer,
        sidebar: sidebarReducer,
        classSubjects: classSubjectsReducer,
        books: booksReducer,
        toggle: toggleReducer,
        product: productReducer,
        currentBook: currentBookReducer,
        activitiesDropdown: activitiesDropdownReducer,
        selectState: selectReducer,
        TOCOpen: TOCOpenReducer,
        bookmarks: bookmarksReducer,
        notes: notesReducer,
        highlights: highlightsReducer,
        initialTOC: initialTOCDataReducer,
        setSelectOpen: setSelectOpen,
        LPOpen: LPOpenReducer,
        WidgetOpen: WidgetOpenReducer,
        WidgetModalOpen: WidgetModalOpenReducer,
        DQBOpen: DQBOpenReducer,
        EvaluateOpen: EvaluateOpenReducer,
        offlineModal: offlineModalReducer,
        IframeDisplay: IframeDisplayReducer,
        SideBarConfig: SideBarConfigReducer,
        SchoolInfo: SchoolInfoReducer,
        ResourceConfig: resourceConfigReducer,
        buildrModal: buildrModalReducer,
        jasper: jasperReducer,
        leadAcademy: leadAcademyReducer,
        lpPdfPlayer: lpPdfPlayerReducer,
        evaluatePdfPlayer: evaluatePdfPlayerReducer,
        CTRBPdfPlayer: CTRBPdfPlayerDataReducer,
        FullScreenModal: FullScreenModalReducer,
        PageView: pageViewReducer,
        jasperIframe: JasperIframeReducer,
        FullScreenMode: FullScreenModeReducer,
        TeacherPendingActionsWidgetOpen: TeacherPendingActionsWidgetOpenReducer,
        SubjectIdPlatformMap: SubjectIdPlatformMapReducer,
        Preference: PreferenceReducer,
        ResourceViewer: ResourceViewerReducer,
        TransparentModal: TransparentModalReducer,
        JasperHeaderSearch: JasperHeaderSearchReducer,
        JasperBooks: JasperBooksReducer,
        AssetViewer: AssetViewerReducer,
        AndroidMediaPlayer: AndroidMediaPlayerReducer,
        [apiClient.reducerPath]: apiClient.reducer,
        [nucluesApiGatewayClient.reducerPath]: nucluesApiGatewayClient.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(apiClient.middleware)
            .concat(nucluesApiGatewayClient.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
